export default function isScrollbarClick(evt: MouseEvent): boolean {
  // Consider clicking the scrollbar as being 20px from the edge of the screen
  return (
    Math.abs(evt.clientX - document.documentElement.clientWidth) < 20 ||
    Math.abs(evt.clientY - document.documentElement.clientHeight) < 20
  );
}
